import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Route,
  Switch
} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { updateParent, setHeight } from '../../lib/modal';

import useBootstrapper from '../../hooks/useBootstrapper';

import PrequalForm from './PrequalForm';
import PrequalResponse from './PrequalResponse';
import Loading from '../shared/Loading';
import Footer from '../shared/Footer';
import { applyUI } from '../../constants/SiteVariables';

import logo from '../../images/ck-nav-logo-2022.svg';

export default function Prequalification({ match }) {
  const prequalification = useSelector(state => state.entities.get('prequalification').last());
  const merchant = useSelector(state => state.entities.get('merchant').last());

  useBootstrapper();

  useEffect(() => {
    // prequal has been deprecated, redirect to apply flow
    if (merchant) {
      window.location = `${applyUI()}/${merchant.slug !== '' ? merchant.slug : merchant.public_key}`
    }
  }, [merchant]);

  useEffect(() => {
    const content = document.getElementById('content');
    setHeight(content.clientHeight + 50);
  }, [prequalification]);

  const dismiss = () => {
    return updateParent('cancel', null);
  }

  const isPrequalified = () => {
    return prequalification && prequalification.status !== '';
  }

  return (
    <div id="content">
      <nav className="header box is-shadowless level is-mobile">
        <div className="level-left">
          <div className="level-item">
            <a className="is-size-5" onClick={dismiss}><FontAwesomeIcon icon={['fal', 'times']} /></a>
          </div>
        </div>

        <div className="level-item">
          <img src={logo} />
        </div>

        <div className="level-right">
          <div className="level-item">
          {merchant && <a id="learn-more" className="is-size-5" href={merchant.learn_more_link} target="_new"><FontAwesomeIcon icon={['fal', 'question-circle']} /></a>}
          </div>
        </div>
      </nav>

      <div id="main-content" className="container">

        {!isPrequalified() && <PrequalForm match={match} />}
        {isPrequalified() && <PrequalResponse />}
      </div>

      <Footer />
    </div>
  )
}
